import { DestroyRef, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, Scroll } from '@angular/router';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { QueryService } from '../../../features/jobs/services/query.service';

@Injectable({ providedIn: 'root' })
export class JobsScrollRestorationService {
  private readonly router = inject(Router);
  private readonly viewportScroller = inject(ViewportScroller);
  private readonly queryService = inject(QueryService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  private pendingScrollPosition: [number, number] | null = null;
  private savedJobsScrollPosition: [number, number] | null = null;

  init(): void {
    if (!this.isBrowser) return;

    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const currentUrl = this.router.url.split('?')[0];
          if (currentUrl === '/jobs') {
            this.savedJobsScrollPosition = [window.scrollX, window.scrollY];
          }
        }

        if (event instanceof Scroll) {
          const url = (event.routerEvent as NavigationEnd).urlAfterRedirects?.split('?')[0];
          const isBack = (event.routerEvent as NavigationEnd).urlAfterRedirects?.includes('isBack=true');

          if (url === '/jobs' && (event.position || isBack)) {
            this.pendingScrollPosition = event.position ?? this.savedJobsScrollPosition;
          } else if (url !== '/jobs') {
            this.viewportScroller.scrollToPosition([0, 0]);
          }
        }
      });

    this.queryService.isQueryLoading
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((loading) => !loading && this.pendingScrollPosition !== null)
      )
      .subscribe(() => {
        const pos = this.pendingScrollPosition!;
        this.pendingScrollPosition = null;
        setTimeout(() => this.viewportScroller.scrollToPosition(pos));
      });
  }
}
